import React, { useState, useEffect } from 'react';
import { useLeagues, useStandings } from '../hooks/useFootball';
import LeagueSelector from '../components/football/LeagueSelector';
import StandingsTable from '../components/football/StandingsTable';
import ErrorMessage from '../components/common/ErrorMessage';

const FootballPage = () => {
  const { leagues, loading: leaguesLoading, error: leaguesError } = useLeagues();
  const [selectedLeague, setSelectedLeague] = useState(null);
  const { standings, loading: standingsLoading, error: standingsError, refetch } = useStandings(selectedLeague);

  // İlk lig yüklendiğinde varsayılan lig seç (Süper Lig veya ilk lig)
  useEffect(() => {
    if (leagues.length > 0 && !selectedLeague) {
      const superLig = leagues.find(l => l.key === 'super-lig');
      setSelectedLeague(superLig ? superLig.key : leagues[0].key);
    }
  }, [leagues, selectedLeague]);

  const selectedLeagueTitle = leagues.find(l => l.key === selectedLeague)?.title || 'Puan Durumu';

  if (leaguesError) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ErrorMessage message={leaguesError} onRetry={() => window.location.reload()} />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Page Header */}
      <header className="mb-8">
        <div className="flex items-center space-x-3 mb-2">
          <div className="w-1.5 h-10 rounded-full bg-green-500"></div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Futbol Puan Durumu
          </h1>
        </div>
        <p className="text-gray-600 dark:text-gray-400 ml-5">
          Liglerin güncel puan durumlarını takip edin
        </p>
      </header>

      {/* League Selector */}
      <section className="mb-6">
        <LeagueSelector
          leagues={leagues}
          selectedLeague={selectedLeague}
          onSelect={setSelectedLeague}
          loading={leaguesLoading}
        />
      </section>

      {/* Selected League Title */}
      {selectedLeague && (
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white flex items-center">
            <svg className="w-6 h-6 mr-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
            </svg>
            {selectedLeagueTitle}
          </h2>
          <button
            onClick={refetch}
            className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            title="Yenile"
          >
            <svg className={`w-5 h-5 text-gray-500 ${standingsLoading ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </button>
        </div>
      )}

      {/* Standings Table */}
      {standingsError ? (
        <ErrorMessage message={standingsError} onRetry={refetch} />
      ) : (
        <StandingsTable standings={standings} loading={standingsLoading} />
      )}
    </div>
  );
};

export default FootballPage;
